var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "监测方案",
        okText: !_vm.formState.id ? "确认并启动" : "确定",
        cancelText: "取消",
        width: "1000px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "监测方案名称",
                        prop: "name",
                      },
                    },
                    [
                      _c("a-input", {
                        attrs: { disabled: !!_vm.formState.id },
                        model: {
                          value: _vm.formState.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "name", $$v)
                          },
                          expression: "formState.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "监测方案级别", prop: "level" } },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: {
                          disabled: !!_vm.formState.id,
                          "dic-key": "MonitPlanLevel",
                        },
                        model: {
                          value: _vm.formState.level,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "level", $$v)
                          },
                          expression: "formState.level",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "监测类型", prop: "type" } },
                    [
                      _c("a-ext-local-dic-select", {
                        attrs: {
                          disabled: !!_vm.formState.id,
                          "dic-key": "MonitPlanType",
                        },
                        model: {
                          value: _vm.formState.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "type", $$v)
                          },
                          expression: "formState.type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "发布来源", prop: "source" } },
                    [
                      _c("a-input", {
                        attrs: { disabled: !!_vm.formState.id },
                        model: {
                          value: _vm.formState.source,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "source", $$v)
                          },
                          expression: "formState.source",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "上传附件", prop: "planFile" } },
                    [
                      _c("a-ext-upload", {
                        attrs: { disabled: !!_vm.formState.id },
                        model: {
                          value: _vm.formState.planFile,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "planFile", $$v)
                          },
                          expression: "formState.planFile",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 0 },
                        wrapperCol: { span: 24 },
                        prop: "childs",
                      },
                    },
                    [
                      _c("a-ext-add-monit-project", {
                        attrs: { disabled: !!_vm.formState.id },
                        model: {
                          value: _vm.formState.childs,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "childs", $$v)
                          },
                          expression: "formState.childs",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }